import { render, staticRenderFns } from "./Browse.Tabs.vue?vue&type=template&id=3a7c01fe&scoped=true&"
import script from "./Browse.Tabs.vue?vue&type=script&lang=js&"
export * from "./Browse.Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c01fe",
  null
  
)

export default component.exports